import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import SubLabel from "components/Atoms/Sublabel";
import { getCityStateCountry } from "shared/utils/addressUtils";

const perPage = 20;

const MultiPromoterList = (props: MultiPickerListProps<server.dto.CompanySmall>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedPromoterInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="promoterlist"
    api={window.CoreApi.Promoter.PaginatedSmall}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={promoter => <div>
      <div>{promoter.name}</div>
      <SubLabel>{getCityStateCountry(promoter.address)}</SubLabel>
    </div>}
    getId={promoter => promoter.companyId}
    getLabel={promoter => <div>{promoter.name}</div>}
    value={props.value}
  />
};

export default MultiPromoterList;